var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPbStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 14.2695V18.4001C25 18.9601 25 19.2401 25.109 19.4541C25.2049 19.6422 25.3578 19.7952 25.546 19.8911C25.7599 20.0001 26.0399 20.0001 26.6 20.0001H30.7305M27 25H19M27 29H19M21 21H19M25 14H19.8C18.1198 14 17.2798 14 16.638 14.327C16.0735 14.6146 15.6146 15.0735 15.327 15.638C15 16.2798 15 17.1198 15 18.8V29.2C15 30.8802 15 31.7202 15.327 32.362C15.6146 32.9265 16.0735 33.3854 16.638 33.673C17.2798 34 18.1198 34 19.8 34H26.2C27.8802 34 28.7202 34 29.362 33.673C29.9265 33.3854 30.3854 32.9265 30.673 32.362C31 31.7202 31 30.8802 31 29.2V20L25 14Z",
    stroke: "#3B3B3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPbStatus);
export default __webpack_public_path__ + "static/media/pb-status.793a85d438a1eea70a1c2aa4b7181ec6.svg";
export { ForwardRef as ReactComponent };